import React, { Component } from 'react';

// Components
import FormInput from '../../../components/Global/Forms/FormInput';
import SelectFormInput from '../../../components/Global/Forms/SelectFormInput';

class SportForm extends Component {
  state = {
    sports: [],
    sportId: '',
    indexInParent: '',
    sportSelectOptions: [],
    selectedSport: '',
    positionSelectOptions: [],
  }

  componentDidMount() {
    const { sports, indexInParent } = this.props;
    let gender = '';

    let sportSelectOptions = sports.map((sport) => {
      gender = sport.gender === 'Mens' ? "(Men's)" : "(Women's)"

      return {value: sport.id, label:  sport.name + ' ' + gender}
    })

    this.setState(state => ({
      ...state,
      sports,
      indexInParent,
      sportSelectOptions
    }))
  }

  componentWillReceiveProps(nextProps) {
    const { sports, selectedSport } = nextProps;

    if (selectedSport.id.value) {
      this.setPositionOptions(selectedSport.id.value, sports);
    }
  }

  setPositionOptions = (sportId, availableSports) => {
    let selectedSport = availableSports.filter((sport) => {
      return sport.id === parseInt(sportId, 10);
    });

    let positionSelectOptions = selectedSport[0].positions.map((position) => {
      return {value: position.id, label: position.name}
    })

    this.setState(state => ({
      ...state,
      positionSelectOptions
    }))
  }

  handleInputChange = (event) => {
    const { indexInParent } = this.state;
    this.props.handleInputChange(event, indexInParent)
  }

  updatePositionSelection = (event, positionIndex) => {
    const {
      indexInParent,
      positionSelectOptions
    } = this.state;

    this.props.updatePositionSelection(event, positionSelectOptions, indexInParent, positionIndex);
  }

  renderPositionSelectors = (positions, positionOptions, disabled, hasError) => {
    const { indexInParent } = this.state;

    return positions.map((position, index) => {
      return (
        <SelectFormInput
          key={
            `${indexInParent}${index}`
          }
          name='position'
          value={position.value}
          onChange={(event) => this.updatePositionSelection(event, index)}
          placeholder="Select a position..."
          selectOptions={positionOptions}
          disabled={disabled}
          errorMessage={position.hasError && !disabled ? 'Please complete this field' : ''}
          showError={hasError && !disabled}
          handleInputRemoval={index > 0 ? () => this.handlePositionRemoval(index) : null}
        />
      )
    })
  }

  handlePositionAddition = () => {
    const { indexInParent } = this.state;

    this.props.handlePositionAddition(indexInParent)
  }

  handlePositionRemoval = (selectorIndex) => {
    const { indexInParent } = this.state;

    this.props.handlePositionRemoval(indexInParent, selectorIndex)
  }

  getFormData = () => {
    return 'Sport Form Data Would Be Here'
  }

  renderRemoveSportFormLink() {
    const { formNumber } = this.props;
    const { indexInParent } = this.state;

    return formNumber > 1
    ? (
      <a
        className="text-link"
        onClick={(event) => this.props.removeSport(event, indexInParent)}
      >
        Remove Sport
      </a>
    )
    : ''
  }

  render() {
    const {
      sportSelectOptions,
      positionSelectOptions
    } = this.state;

    const {
      selectedSport
    } = this.props;

    let disabled = selectedSport.id.value ? false : true;

    return (
      <div className="onboarding-sport-selection-sport-form">
        <div className="onboarding-sport-selection-sport-form-sport-header">
          <label>
            Sport
          </label>
          {this.renderRemoveSportFormLink()}
        </div>
        <SelectFormInput
          name='id'
          value={selectedSport ? selectedSport.id.value : ''}
          onChange={this.handleInputChange}
          placeholder="Select a sport..."
          selectOptions={sportSelectOptions}
          errorMessage={selectedSport.id.hasError ? 'Please complete this field' : ''}
          showError={selectedSport.id.hasError ? true : false}
        />
        <FormInput
          label='Jersey Number (optional)'
          name='jersey_number'
          type='text'
          value={selectedSport.jersey_number.value}
          onChange={this.handleInputChange}
          selectOptions={sportSelectOptions}
          disabled={disabled}
          errorMessage={selectedSport.jersey_number.hasError && !disabled ? 'Please complete this field.' : ''}
          showError={selectedSport.jersey_number.hasError && !disabled ? true : false}
        />
        <label className={disabled ? 'disabled' : null}>
          Positions
        </label>
        {this.renderPositionSelectors(selectedSport.positions, positionSelectOptions, disabled, true)}
        <a
          onClick={this.handlePositionAddition}
          className={`onboarding-sport-selection-sport-form-add-position${disabled ? ' disabled' : ''}`}
        >
          Add Another Position
        </a>
      </div>
    );
  }
}

export default SportForm;



// WEBPACK FOOTER //
// ./src/screens/Onboarding/Forms/SportForm.js